import { render } from "./CourseOutcomesDialog.vue?vue&type=template&id=82a276f6"
import script from "./CourseOutcomesDialog.vue?vue&type=script&lang=js"
export * from "./CourseOutcomesDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__